export default {"src":"/_next/static/media/ReviewLogo1.9a7a99cb.svg","height":127,"width":186,"blurWidth":0,"blurHeight":0};